/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrototypeInstallLogModel
 */
export interface PrototypeInstallLogModel {
    /**
     * 
     * @type {string}
     * @memberof PrototypeInstallLogModel
     */
    firmware_id: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeInstallLogModel
     */
    mac_address: string;
}

/**
 * Check if a given object implements the PrototypeInstallLogModel interface.
 */
export function instanceOfPrototypeInstallLogModel(value: object): value is PrototypeInstallLogModel {
    if (!('firmware_id' in value) || value['firmware_id'] === undefined) return false;
    if (!('mac_address' in value) || value['mac_address'] === undefined) return false;
    return true;
}

export function PrototypeInstallLogModelFromJSON(json: any): PrototypeInstallLogModel {
    return PrototypeInstallLogModelFromJSONTyped(json, false);
}

export function PrototypeInstallLogModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrototypeInstallLogModel {
    if (json == null) {
        return json;
    }
    return {
        
        'firmware_id': json['firmware_id'],
        'mac_address': json['mac_address'],
    };
}

export function PrototypeInstallLogModelToJSON(json: any): PrototypeInstallLogModel {
    return PrototypeInstallLogModelToJSONTyped(json, false);
}

export function PrototypeInstallLogModelToJSONTyped(value?: PrototypeInstallLogModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmware_id': value['firmware_id'],
        'mac_address': value['mac_address'],
    };
}

